import { LoginScreen } from "@/src/screens/login-screen";

export default function LoginRoute() {
  return <LoginScreen />;
}
